<div class="navpositions" [ngStyle]="{'background-color': headerbackgroundColor}">
  <div class="first-nav">
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <button *ngIf="!isGoldCoinsPage" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse collapsepositions" id="navbarNav">
          <div class="container">
            <div class="row">
              <div class="col-md-2 coltwo">
                <img routerLink="/" src="../../assets/GoldBharatone.png" class="goldbharathimg" alt="" />
              </div>
              <div class="col-md-7 colseven">
                <div class="listdiv">
                  <ul class="underlist" [ngStyle]="{'background-color': activeBorderColor }">
                    <li routerLink="/home" routerLinkActive="active" class="listdiv">Home</li>
                    <li routerLink="/aboutus" routerLinkActive="active" class="listdiv">About Us</li>
                    <li routerLink="/products" routerLinkActive="active" class="listdiv">Products</li>
                    <li routerLink="/policy" routerLinkActive="active" class="listdiv">Privacy Policy</li>
                    <li routerLink="/Booking" routerLinkActive="active" class="listdiv">Contact Us</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-3 colthree">
                <div class="mainbotn">
                  <div *ngIf="isLogin">
                    <div class="icon-container" routerLink="/notifications">
                      <img class="vector-img" src="../../assets/images/blackvec.png">
                      <span class="notColor">{{notLength}}</span>
                    </div>
                    <span class="userDetails">Welcome, {{ userLog?.business_name.length > 10 ? (userLog?.business_name
                      | slice:0:10) + '..' : userLog?.business_name }}</span>&nbsp;&nbsp;
                    <a class="user-logo-letter" data-bs-toggle="modal"
                      data-bs-target="#exampleModalLogout">{{userLog?.business_name | slice: 0 : 1}}</a>
                  </div>
                  <div *ngIf="!isLogin" class="mysecbotns">
                    <button class="registerbotn" routerLink="/register">Register</button>
                    <button class="loginbotn" [ngStyle]="{'background-color': loginButtonColor}"
                      routerLink="/login">Login</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>

  <div class="second-nav">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <button *ngIf="!isGoldCoinsPage" class="navbar-toggler" type="button" (click)="toggleForm()" data-bs-toggle="collapse"
          data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div>
          <img routerLink="/" src="../../assets/GoldBharatone.png" class="goldbharathimg" alt="" />
        </div>

        <div class="collapse navbar-collapse collapsepositions" id="navbarNav">
          <div *ngIf="showForm">
            <div class="container second-con">
              <div class="row">
                <div class="col-md-6 col-five">
                  <div class="listdiv">
                    <ul class="underlist" (click)="toggleForm()">
                      <li routerLink="/home" routerLinkActive="active">Home</li>
                      <div></div>
                      <li routerLink="/aboutus" routerLinkActive="active">About Us</li>
                      <div></div>
                      <li routerLink="/products" routerLinkActive="active">Products</li>
                      <div></div>
                      <li routerLinkActive="active" routerLink="/policy">Privacy Policy</li>
                      <div></div>
                      <li routerLink="/Booking" routerLinkActive="active">Contact Us</li>
                      <div></div>
                      <li *ngIf="isLogin" data-bs-toggle="modal" class="profileMobile"
                        data-bs-target="#exampleModalLogout">
                        <i class="fa-solid fa-user"></i> Profile
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-md-6 col-four">
                  <div class="mainbotn">
                    <div *ngIf="!isLogin">
                      <button class="registerbotn" routerLink="/register">Register</button>
                      <button class="loginbotn" routerLink="/login">Login</button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>

<!-- LOGOUT / PROFILE MODAL -->
<div class="modal fade header-logoutnav" id="exampleModalLogout" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="my-profiles-div">
          <p class="visitprofile">{{userLog?.proprietor_name | slice: 0 : 1}}</p>
          <div>
            <h5 class="heading-profile-man">{{userLog?.proprietor_name}}</h5>
            <p class="para-person-main">{{userLog?.user_id}}</p>
            <p class="para-person-main">{{userLog?.email}}</p>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="position: absolute;
            padding-right: 45px;
            right: 0;
            margin-top: -40px;
          "></button>
        </div>

        <div class="shield-div" *ngIf="userLog?.kyc_status==0" routerLink="/update-kyc" data-bs-dismiss="modal"
          aria-label="Close">
          <img src="../../assets/ShieldDone.png" class="shiledimages" alt="" />
          <p>KYC</p>
        </div>
        <div class="shield-div" *ngIf="userLog?.kyc_status!=0" routerLink="/kyc_details" data-bs-dismiss="modal"
          aria-label="Close">
          <img src="../../assets/ShieldDone.png" class="shiledimages" alt="" />
          <p>KYC</p>
        </div>
<div class="power-play-div"
     [routerLink]="['/orders']"
     [queryParams]="{
       orderType: 'Coins',
     }"
     data-bs-dismiss="modal">
<i class="fa-solid fa-coins"></i>
  <!-- <img src="../../assets/images/Gold-coin.png" class="power-on-off" alt=""><p class="margin-coin-newww"><span><img class="power-on-offff" alt="" src="../../assets/images/silvercoin.png"></span></p> -->
  <p>Coin Orders</p>

</div>
        <div class="power-play-div" routerLink="/orders" data-bs-dismiss="modal" aria-label="Close">
          <img src="../../assets/checkout.png" class="power-on-off" alt="" />
          <p>Orders</p>
        </div>
        <div class="power-play-div" routerLink="/margin" data-bs-dismiss="modal" aria-label="Close">
          <img src="../../assets/margin.png" class="power-on-off" alt="" />
          <p>Margin</p>
        </div>
        <div class="power-play-div" routerLink="/rate-alert" data-bs-dismiss="modal" aria-label="Close">
          <img src="../../assets/alert.png" class="power-on-off" alt="" />
          <p>Rate Alert</p>
        </div>
        <div class="power-play-div" routerLink="/history" data-bs-dismiss="modal" aria-label="Close">
          <img src="../../assets/history.png" class="power-on-off" alt="" />
          <p>Gold History</p>
        </div>
        <div class="power-play-div" (click)="logOut()">
          <img src="../../assets/powerplay.png" class="power-on-off" alt="" />
          <p class="text-danger mb-0">Log Out</p>
        </div>
      </div>
    </div>
  </div>
</div>